var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"config":_vm.modalConfig},on:{"cancel":_vm.onCancel}},[_c('span',{attrs:{"slot":"modalContent"},slot:"modalContent"},[_c('OtpInput',{attrs:{"otpConfig":_vm.otpConfig}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }